import { DEFAULT_DIALOG_WIDTH } from '@abb-procure/constants';
import { CriteriaSubDimension } from '@abb-procure/data';
import { Overlay } from '@angular/cdk/overlay';
import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import type {
  DimensionDialog,
  DimensionDialogData,
} from '../components/dimension-dialog/dimension-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DimensionDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly overlay = inject(Overlay);

  async openDimensionDialog(
    data: DimensionDialogData,
  ): Promise<MatDialogRef<DimensionDialog, CriteriaSubDimension>> {
    const module =
      await import('../components/dimension-dialog/dimension-dialog.component');

    const dialog = this.dialog.open<
      DimensionDialog,
      DimensionDialogData,
      CriteriaSubDimension
    >(module.DimensionDialog, {
      data,
      width: DEFAULT_DIALOG_WIDTH,
      panelClass: ['dimension-dialog'],
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });

    return dialog;
  }
}
